export const UPDATE_TITLE = 'UPDATE_TITLE';
export const UPDATE_VERSION = 'UPDATE_VERSION';
export const UPDATE_DATE = 'UPDATE_DATE';
export const OPEN_NAV = 'OPEN_NAV';
export const CLOSE_NAV = 'CLOSE_NAV';
export const HIDE_NAV = 'HIDE_NAV';
export const EXPORT_IMAGE = 'EXPORT_IMAGE';
export const SAVE_FILE = 'SAVE_FILE';
export const OPEN_FILE = 'OPEN_FILE';
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const SAVE_NOTE = 'SAVE_NOTE';
export const UPDATE_NOTE_TITLE = 'UPDATE_NOTE_TITLE';
export const UPDATE_NOTE_DESCRIPTION = 'UPDATE_NOTE_DESCRIPTION';
export const UPDATE_STATE_FROM_FILE_DATA = 'UPDATE_STATE';
export const UPDATE_NOTE_BACKGROUND_COLOR = 'UPDATE_NOTE_BACKGROUND_COLOR';
export const UPDATE_NOTE_COLOR = 'UPDATE_NOTE_COLOR';
export const RESET_NOTE_COLOR = 'RESET_NOTE_COLOR';
export const DELETE_NOTE = 'DELETE_NOTE';
export const EDIT_NOTE = 'EDIT_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
